<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    {{post && post.id ? ('bikeshop.posts.update_post' | translate) : ('bikeshop.posts.create_post' | translate)}}
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span class="hubtiger-close"></span>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-md-6">
      <div class="smartphone">
        <div class="smartphone-content">
          <div class="post-card">
            <div class="partner">
              <img src="{{ partnerLogo }}" />
              <p>{{ partnerName }}</p>
            </div>
            <p class="text-content">{{ postForm.value.content }}</p>
            <div class="media-content">
              <div *ngFor="let image of images">
                <img src="{{image.mediaURL}}" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <form class="col-md-6" [formGroup]="postForm">
      <div class="row margin-top-8">
        <div class="col-md-12 label">{{'bikeshop.posts.post_content' | translate}}:</div>
        <div class="col-md-12">
          <textarea [rows]="8" pInputTextarea formControlName="content"></textarea>
        </div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-12 label">{{'bikeshop.posts.external_url' | translate}}:</div>
        <div class="col-md-12">
            <input type="text" pInputText formControlName="externalLink" />
        </div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-12 label" *ngIf="images && images.length>0">{{'bikeshop.posts.media' | translate}}:</div>
        <div class="col-md-12">
          <div class="image-list">
            <div *ngFor="let image of images;let i = index">
              <div>
                <span class="fa fa-times remove-image" (click)="removeImage(i)"></span>
                <img src="{{image.mediaURL}}" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-8">
          <button pButton class="full-width accent" label="{{'bikeshop.posts.upload_media' | translate}}" (click)="fileUpload.click()"></button>
          <!--<p-fileUpload name="myfile[]" styleClass="alternate width-100" chooseLabel="Upload" mode="basic"
            customUpload="true" auto="true" (uploadHandler)="myUploader($event)"></p-fileUpload>-->
          <input #fileUpload type="file" multiple accept="image/*;capture=camera" style="display: none" (change)="myUploader($event)">
        </div>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <div class="row">
    <div class="col-md-3">
      <button pButton class="full-width alternate" label="Cancel" (click)="modal.dismiss()"></button>
    </div>
    <div class="col-md-3"></div>
    <div class="col-md-3">
      <button pButton *ngIf="post && post.id" class="full-width" label="{{'bikeshop.posts.delete' | translate}}"
      (click)="deletePost()" [disabled]="saving"></button>
    </div>
    <div class="col-md-3">
      <button pButton class="full-width" label="{{post && post.id ? ('bikeshop.posts.update' | translate) : ('bikeshop.posts.create' | translate)}}"
        (click)="send(postForm.value)" [disabled]="!postForm.valid || saving"></button>
    </div>
  </div>
</div>
<p-confirmDialog key="delete_post"></p-confirmDialog>